import { Component, Input } from '@angular/core';
import { EventGuestModel } from '@app/events/shared/event-guest.model';

@Component({
  selector: 'app-guest-name-column',
  standalone: true,
  templateUrl: './guest-name-column.component.html',
})
export class GuestNameColumnComponent {
  @Input('item') protected item!: EventGuestModel;
  @Input() protected nameOnly = false;
}
